export class AdminPanel {
  GroupName: string;
  Description: string;
}
